
const modalDatos =(getModals)=>{

      getModals.forEach(modal =>{
         const getTriggerClass = modal.dataset.set;
         const getTriggerTime = modal.dataset.auto

         if(getTriggerClass != ''){
            const allModalTriggers = document.querySelectorAll(`.${getTriggerClass}`);
            letShowModals(allModalTriggers, modal);
         }

         if(getTriggerTime != ''){
            modalSetTime(getTriggerTime, modal)
         }
         
      })

}

const letShowModals = (allModalTriggers, modal) =>{

   allModalTriggers.forEach(trigger =>{

      trigger.addEventListener('click', event =>{
         modal.classList.add('has-show-modal');
         document.body.style.overflow = 'hidden';
      })
   })

}


const modalSetTime = (getTriggerTime, modal)=>{
   let getConfirmation = localStorage.getItem("motalWasTrigged");
   
   if(getConfirmation == null){

      let modalIsTrigged = true;
      localStorage.setItem('motalWasTrigged', modalIsTrigged);
   
      setTimeout(() => {
         modal.classList.add('has-show-modal');
         document.body.style.overflow = 'hidden';
       }, getTriggerTime) 
   }
}

const closeModal =(getModals)=>{
   const getClosers = document.querySelectorAll('.dashicons-no-alt');
   const getModalContent = document.querySelectorAll('.modal-contents');
   

   getModalContent.forEach( divElement =>{
      divElement.addEventListener('click', event=>{
         const ContainTarget = event.target;
         if( ContainTarget.classList.contains('modal-contents')){
            ContainTarget.classList.remove('has-show-modal')
            document.body.style.overflow = '';
         }
      })
   })
   
   getClosers.forEach(closer =>{
      closer.addEventListener('click', event=>{
         
         getModals.forEach(modal =>{           
            if(modal.classList.contains('has-show-modal')){
               modal.classList.remove('has-show-modal');
               document.body.style.overflow = '';
            }
         })
      
      })
   })

   
}


window.addEventListener('load', (event) => {

   const getModals = document.querySelectorAll('.modal-contents');
   modalDatos(getModals);
   closeModal(getModals);

});
